import _get from 'lodash/get'
import { Map } from 'immutable'
import { get as getConfig } from '../../config/index'
import { SET_APP_BOOTSTRAP_PHASE } from '../app/actions'
import { SET_RESOLVER_DATA } from '../resolver/actions'
import { getAuthIsLoggedIn } from '../auth/index'
import { SET_AUTH_LOGIN_SUCCESS } from '../auth/actions'
import { getUserPortalMetaData } from '../portal/index'
import { setUserRequestCountry } from './actions'
import { getUserRequestCountry } from './index'
import {
  URL_ACCOUNT_SETTINGS,
} from '../url/constants'
import { ROLE_ID_AMBASSADOR } from '../auth-access/index'
import { getAmbassador } from '../ambassadors/index'
import { AMBASSADORS_SET_DETAILS, AMBASSADORS_SET_DETAILS_PROCESSING } from '../ambassadors/actions'
import * as actions from './actions'

const config = getConfig()
const manageEmailCommunication = !!_get(config, ['features', 'userAccount', 'manageEmailCommunication'])

function isAccountSettings ({ state }) {
  const { resolver, auth } = state
  const path = resolver.getIn(['data', 'path'])
  const isLoggedIn = getAuthIsLoggedIn(auth)

  return path === URL_ACCOUNT_SETTINGS && isLoggedIn && manageEmailCommunication
}

export function watchUserPortalMetadata ({ after }) {
  return after(
    [actions.SET_USER_DATA],
    async ({
      dispatch, state, action,
    }) => {
      const { auth } = state

      if (
        (getAuthIsLoggedIn(auth) && action.type === actions.SET_USER_DATA)
      ) {
        dispatch({
          type: actions.SET_USER_PORTAL_METADATA_PROCESSING,
          payload: true,
        })

        const data = await getUserPortalMetaData({ auth })

        dispatch({
          type: actions.SET_USER_PORTAL_METADATA,
          payload: { data, processing: false },
        })
      }
    },
  )
}

export function watchUserAmbassadorRole ({ after }) {
  return after(
    [SET_APP_BOOTSTRAP_PHASE],
    async ({
      dispatch, state, prevState,
    }) => {
      const { auth } = state
      const { app } = state
      const { app: prevApp } = prevState
      const currentBootstrapComplete = app.get('bootstrapComplete')
      const prevBootstrapComplete = prevApp.get('bootstrapComplete')

      if (
        currentBootstrapComplete
        && prevBootstrapComplete !== currentBootstrapComplete
        && getAuthIsLoggedIn(auth)
        && auth.get('roleIds').includes(ROLE_ID_AMBASSADOR)
      ) {
        dispatch({
          type: AMBASSADORS_SET_DETAILS_PROCESSING,
          payload: { processing: true },
        })

        const data = await getAmbassador({ auth })
        const error = _get(data, 'errors')

        dispatch({
          type: AMBASSADORS_SET_DETAILS,
          payload: {
            data: error ? {} : data,
            error,
          },
        })
      }
    },
  )
}

export function watchAccountSettingsBootstrap ({ after }) {
  return after(
    [SET_APP_BOOTSTRAP_PHASE],
    async ({
      dispatch, state, prevState,
    }) => {
      const { app } = state
      const { app: prevApp } = prevState
      const currentBootstrapComplete = app.get('bootstrapComplete')
      const prevBootstrapComplete = prevApp.get('bootstrapComplete')

      if (currentBootstrapComplete && prevBootstrapComplete !== currentBootstrapComplete) {
        dispatch(actions.getUserContactData())
      }
    },
  )
    .when(isAccountSettings)
}

export function watchAccountSettingsSetResolverData ({ after }) {
  return after(
    [SET_RESOLVER_DATA],
    async ({
      dispatch,
    }) => {
      dispatch(actions.getUserContactData())
    },
  )
    .when(isAccountSettings)
}

export function watchRequestCountryBootstrap ({ after }) {
  return after(
    [SET_APP_BOOTSTRAP_PHASE],
    async ({
      dispatch, state, prevState,
    }) => {
      const { app } = state
      const { app: prevApp } = prevState
      const currentBootstrapComplete = app.get('bootstrapComplete')
      const prevBootstrapComplete = prevApp.get('bootstrapComplete')

      if (currentBootstrapComplete && prevBootstrapComplete !== currentBootstrapComplete) {
        const { user } = state
        const existingCountry = Map.isMap(user)
          ? user.getIn(['data', 'requestCountry'])
          : undefined
        if (existingCountry) {
          return
        }

        const result = await getUserRequestCountry()
        const country = result?.requestCountry || result?.country

        if (country) {
          dispatch(setUserRequestCountry(country))
        }
      }
    },
  )
}

// When the user logs in, sync up the auth country and the user request country
// chances of the countries being out of sync is probably pretty low...
// user request country is applied after bootstrap via watchRequestCountryBootstrap
export function watchAuthLoginSuccess ({ after }) {
  return after(
    [SET_AUTH_LOGIN_SUCCESS],
    async ({
      dispatch,
      state,
    }) => {
      const { auth, user } = state
      const authCountry = auth.get('country')
      const userRequestCountry = user.getIn(['data', 'requestCountry'])

      if (authCountry && authCountry !== userRequestCountry) {
        dispatch(setUserRequestCountry(authCountry))
      }
    },
  )
}
